export default {
  GET_ALBUM_PLAY_LIST: '/Share/Playlist',
};
